import { isStringNullOrWhiteSpace } from 'owa-localize';

export default function truncateUrlForItemLocation(url: string): string {
    if (isStringNullOrWhiteSpace(url)) {
        return url;
    }

    const end: number = url.lastIndexOf('/');
    return end >= 1 ? url.substr(0, end) : url;
}
